import { z } from "zod";
import { ClientId, DateSchema } from "../../Types";
import { GoalBasedFinancialPlanIdSchema, GoalBasedFinancialPlanIncomeIdSchema, GoalBasedFinancialPlanSavingsIdSchema, } from "../ids";
import { GoalBasedFinancialPlanAssetLiabilityId, GoalBasedPlanDateRequest, GoalBasedPlanDateResponse, GoalBasedRepeatTimeFrameSchema, } from "../types";
export const GoalBasedEmployerMatchType = z.enum([
    "PercentageOfSalary",
    "DollarAmount",
    "No",
]);
export const GoalBasedFinancialPlanSavingsResponseSchema = z.object({
    savingsId: GoalBasedFinancialPlanSavingsIdSchema,
    goalBasedFinancialPlanId: GoalBasedFinancialPlanIdSchema,
    owner: ClientId,
    name: z.string(),
    account: GoalBasedFinancialPlanAssetLiabilityId,
    fundingSource: GoalBasedFinancialPlanIncomeIdSchema,
    contribution: z.string(),
    employerMatchType: GoalBasedEmployerMatchType,
    employerMatchValue: z.string().optional(),
    startDate: GoalBasedPlanDateResponse.optional(),
    endDate: GoalBasedPlanDateResponse.optional(),
    repeats: GoalBasedRepeatTimeFrameSchema,
    createdAt: DateSchema,
    updatedAt: DateSchema,
});
export const GoalBasedFinancialPlanSavingsPostRequestSchema = z.object({
    owner: ClientId,
    name: z.string(),
    account: GoalBasedFinancialPlanAssetLiabilityId,
    fundingSource: GoalBasedFinancialPlanIncomeIdSchema,
    contribution: z.string(),
    employerMatchType: GoalBasedEmployerMatchType,
    employerMatchValue: z.string().optional(),
    startDate: GoalBasedPlanDateRequest.nullish(),
    endDate: GoalBasedPlanDateRequest.nullish(),
    repeats: GoalBasedRepeatTimeFrameSchema,
});
export const GoalBasedFinancialPlanSavingsPatchRequestSchema = GoalBasedFinancialPlanSavingsPostRequestSchema.partial();
export const GoalBasedFinancialPlanSavingsDeleteResponseSchema = z.object({
    message: z.string(),
});
//# sourceMappingURL=types.js.map